import React from 'react';
import { NavLink } from "react-router-dom";
import moment from 'moment';
import Logos from '../../pages/parcels/form_v3/logos';
import Info from '../Info';
import { costFormat } from '../../services/cost';

const PARCEL_TYPE_DOC = 1;

function formatDate(value) {
    return value ? moment(value).format('DD.MM.YYYY') : null;
}

function getParcelTypeLabel(parcelType) {
    if (parcelType == null || parcelType === '') {
        return '';
    }
    if (typeof parcelType === 'string') {
        const normalized = parcelType.toLowerCase();
        if (normalized === 'document' || normalized === 'документы') {
            return 'Документы';
        }
        if (normalized === 'cargo' || normalized === 'груз' || normalized === 'pallets' || normalized === 'паллеты') {
            return 'Груз';
        }
        return parcelType;
    }
    return parcelType === PARCEL_TYPE_DOC ? 'Документы' : 'Груз';
}

function getPlannedDeliveryDate(parcel) {
    if (parcel.selectedTariff && parcel.selectedTariff.maxDeliveryTime) {
        return formatDate(parcel.selectedTariff.maxDeliveryTime);
    }
    if (parcel.initialPlannedDeliveryDate) {
        return formatDate(parcel.initialPlannedDeliveryDate);
    }
    return '-';
}

const getParcelUrl = (parcelId) => {
    return `/parcels/${parcelId}/new?cameFrom=parcels`;
};

/**
 * Компактная сводка посылки для модалки оценки ТК (по образцу top-block формы).
 */
export default function CarrierReviewParcelSummary({ parcel }) {
    if (!parcel) {
        return null;
    }

    const tariff = parcel.selectedTariff || {};
    const shipmentCity = (parcel.shipmentAddress || {}).city;
    const deliveryCity = (parcel.deliveryAddress || {}).city;
    const typeLabel = getParcelTypeLabel(parcel.parcelType);

    return (
        <div className="carrier-review-modal__parcel-summary">
            <div>
                <div className="carrier-review-modal__parcel-summary-number">
                    №&nbsp;<NavLink
                        style={{ color: '#459EFF' }}
                        className='total__change-btn_name'
                        to={getParcelUrl(parcel.id)}
                        target="_blank"
                        rel="noopener noreferrer"
                    >{parcel.number}</NavLink>
                </div>
                <div className="c_black">
                    <b>{typeLabel}</b>
                </div>
                <div>Расч/вес: <span className="c_black">{parcel.weight} кг.</span></div>
                <div>
                    Факт/вес:{' '}
                    {parcel.actualWeight
                        ? (
                            <b className={parcel.actualWeight !== parcel.weight ? 'c_blue' : 'c_black'}>
                                {parcel.actualWeight} кг.
                            </b>
                        )
                        : '-'}
                </div>
                <div>
                    Объём/вес:{' '}
                    {parcel.volumeWeight
                        ? <span className="c_black">{parcel.volumeWeight} кг.</span>
                        : '-'}
                </div>
            </div>
            <div className="dates">
                <div>
                    <div className="c_black">{formatDate(parcel.departureDate)}</div>
                    <div className="carrier-review-modal__parcel-summary-caption">Плановая дата отгрузки</div>
                    {parcel.actualDepartureDate && (
                        <div>
                            <div className="c_black carrier-review-modal__parcel-summary-date">
                                {formatDate(parcel.actualDepartureDate)}
                            </div>
                            <div className="carrier-review-modal__parcel-summary-caption">Фактическая дата отгрузки</div>
                        </div>
                    )}
                </div>
                <div>
                    <div className="c_black">{getPlannedDeliveryDate(parcel)}</div>
                    <div className="carrier-review-modal__parcel-summary-caption">Плановая дата доставки</div>
                    {parcel.actualDeliveryDate && (
                        <div>
                            <div className="c_black carrier-review-modal__parcel-summary-date">
                                {formatDate(parcel.actualDeliveryDate)}
                            </div>
                            <div className="carrier-review-modal__parcel-summary-caption">Фактическая дата доставки</div>
                        </div>
                    )}
                    {parcel.storagePeriodEnd && (
                        <div>
                            <div className="c_black carrier-review-modal__parcel-summary-date">
                                {formatDate(parcel.storagePeriodEnd)}
                            </div>
                            <div className="carrier-review-modal__parcel-summary-caption">Срок хранения до</div>
                        </div>
                    )}
                    {!parcel.storagePeriodEnd && parcel.storagePeriodDays != null && (
                        <div>
                            <div className="c_black carrier-review-modal__parcel-summary-date">
                                {parcel.storagePeriodDays}
                            </div>
                            <div className="carrier-review-modal__parcel-summary-caption">Срок хранения, дней</div>
                        </div>
                    )}
                </div>
            </div>
            <div className="points">
                <div>
                    <div className="c_black">{shipmentCity || '-'}</div>
                    <div>{parcel.senderCompanyName}</div>
                    <div>{parcel.senderName}</div>
                </div>
                <div>
                    <div className="c_black">{deliveryCity || '-'}</div>
                    <div>{parcel.recipientCompanyName}</div>
                    <div>{parcel.recipientName}</div>
                </div>
            </div>
            <div className="shipment-company">
                {tariff.carrierName && (
                    <Info
                        name={tariff.carrierName}
                        label={tariff.carrierServiceName}
                        text={tariff.carrierServiceDescription}
                        position="right"
                        offset={[7]}
                    />
                )}
                <div className="shipment-company__carrier">
                    <Logos
                        name={tariff.carrierCode}
                        carrierTitle={tariff.carrierName}
                    />
                </div>
            </div>
            <div>
                <div>
                    Фактическая стоимость, р. с НДС:
                    <div className={`${parcel.actualDeliveryCost !== parcel.deliveryCost ? 'c_blue ' : ''}f-s_18`}>
                        {parcel.actualDeliveryCost
                            ? <b>{costFormat(parcel.actualDeliveryCost)} ₽</b>
                            : '-'}
                    </div>
                </div>
                <div className="carrier-review-modal__parcel-summary-cost">
                    Расчетная стоимость:
                    <div className="c_black">{costFormat(parcel.deliveryCost)} ₽</div>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./App/components/CarrierReview/CarrierReviewParcelSummary.jsx